/** A persisted grant is active only before its optional expiry. Never changes billing data. */
export function premiumExpiryTime(expiry: unknown): number | null {
  if (expiry === null || expiry === undefined) return null;
  if (expiry instanceof Date) return expiry.getTime();
  if (typeof expiry === 'string' && expiry.trim()) return Date.parse(expiry);
  return NaN;
}

export function isPremiumActive(flag: unknown, expiry: unknown, now = Date.now()): boolean {
  if (!(flag === true || flag === 1 || flag === '1') || !Number.isFinite(now)) return false;
  const until = premiumExpiryTime(expiry);
  return until === null || (Number.isFinite(until) && until > now);
}

/** Convert the database's local Date/SQL datetime to one unambiguous API instant. */
export function serializePremiumExpiry(expiry: unknown): string | null {
  const until = premiumExpiryTime(expiry);
  return until !== null && Number.isFinite(until) ? new Date(until).toISOString() : null;
}

// Default export also supports the ESM client importing this shared CommonJS package in tests.
export default { isPremiumActive, premiumExpiryTime, serializePremiumExpiry };
